export const customColumns = [
    { label: 'Sponsor', key: 'sponsor', checked: true },
    { label: 'Protocol/Trial ID', key: 'protocol_trial_id', checked: true },
    { label: 'Binder Type', key: 'binder_type', checked: true },
    { label: 'Unfiled Documents', key: 'unfiled_documents', checked: true },
    { label: 'Pending Tasks', key: 'pending_tasks', checked: true },
    { label: 'Activation Date', key: 'activation_date', checked: false },
    { label: 'Contact', key: 'contact', checked: false },
    { label: 'Creation Date', key: 'creation_date', checked: false },
    { label: 'CRO', key: 'cro', checked: false },
    { label: 'Study Stage', key: 'study_stage', checked: true },
    { label: 'Status', key: 'status', checked: false },
    { label: 'Site Number', key: 'site_number', checked: false },
    { label: 'Department', key: 'department', checked: false },
    { label: 'Site', key: 'site', checked: false },
    { label: 'Disease Group', key: 'disease_group', checked: false },
    { label: 'Template', key: 'template', checked: false },
    { label: 'IRB/IEC Number', key: 'IRB_IEC_number', checked: false },
    { label: 'Principal Investigator', key: 'principal_investigator', checked: false },
    { label: 'IRB / IEC Renewal Date', key: 'renewal_date', checked: false },
    { label: 'ClinicalTrials.gov Number', key: 'ct_gov_number', checked: false },
];